import React, { useState } from "react";

/*
 * On-device preview, mirroring the preview panel of the Firebase console.
 * Indicative only — the real thing depends on the OS and the app version.
 */
function DevicePreview({ title, body, imageUrl, appName = "PRINCIPAL TH" }) {
  const [platform, setPlatform] = useState("android");

  const previewTitle = title || "ชื่อเรื่องการแจ้งเตือน";
  const previewBody = body || "ข้อความแจ้งเตือนจะแสดงตรงนี้";
  const now = new Date();
  const clock = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

  return (
    <div className="push-noti-preview">
      <div className="push-noti-preview-tabs">
        <button
          type="button"
          className={platform === "android" ? "push-noti-preview-tab active" : "push-noti-preview-tab"}
          onClick={() => setPlatform("android")}
        >
          ANDROID
        </button>
        <button
          type="button"
          className={platform === "ios" ? "push-noti-preview-tab active" : "push-noti-preview-tab"}
          onClick={() => setPlatform("ios")}
        >
          iOS
        </button>
      </div>

      <div className="push-noti-preview-device">
        <div className="push-noti-preview-screen">
          <div className="push-noti-preview-clock">{clock}</div>

          {platform === "android" ? (
            <div className="push-noti-card push-noti-card-android">
              <div className="push-noti-card-header">
                <span className="push-noti-card-appicon" />
                <span className="push-noti-card-appname">{appName}</span>
                <span className="push-noti-card-time">ตอนนี้</span>
              </div>
              <p className="push-noti-card-title">{previewTitle}</p>
              <p className="push-noti-card-body">{previewBody}</p>
              {imageUrl ? (
                <img
                  className="push-noti-card-image"
                  src={imageUrl}
                  alt="notification"
                  onError={event => {
                    event.target.style.display = "none";
                  }}
                />
              ) : null}
            </div>
          ) : (
            <div className="push-noti-card push-noti-card-ios">
              <div className="push-noti-card-header">
                <span className="push-noti-card-appicon" />
                <span className="push-noti-card-appname">{appName}</span>
                <span className="push-noti-card-time">ตอนนี้</span>
              </div>
              <p className="push-noti-card-title">{previewTitle}</p>
              <p className="push-noti-card-body">{previewBody}</p>
              {imageUrl ? (
                <img
                  className="push-noti-card-image"
                  src={imageUrl}
                  alt="notification"
                  onError={event => {
                    event.target.style.display = "none";
                  }}
                />
              ) : null}
            </div>
          )}
        </div>
      </div>

      <p className="push-noti-preview-note">
        ตัวอย่างเพื่อดูเลย์เอาต์คร่าว ๆ เท่านั้น
      </p>
    </div>
  );
}

export default DevicePreview;
